export default __webpack_public_path__ + "static/media/CombChar.969cc4f7.jpg";